import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { takeUntil } from 'rxjs/operators';
import { RolesConstants } from '@shared/constants';
import { LocationModel } from '../../../customers/models/location.model';
import { LocationAPI } from '../../services/location-api.service';
import { SectionState } from '../../enums/layout.enum';
import { RoutesUtil } from '../../utils/routes.util';
import { AddLocationType, CompanyLabelType, LocationType } from '../../enums/shared-enums.enum';
import { BaseComponent } from '../base-component/base.component';
import { Router } from '@angular/router';
import { UserApi } from '@shared-features/services';
import { LocationStatus } from '@shared-features/enums/location-status.enum';
import { MatDialog } from '@angular/material/dialog';
import { DialogLayoutComponent } from '@shared/components/dialog-layout/dialog-layout.component';

@Component({
  selector: 'app-locations-list',
  templateUrl: './locations-list.component.html',
  styleUrls: ['./locations-list.component.scss'],
})
export class LocationsListComponent extends BaseComponent implements OnChanges {
  dataSource: MatTableDataSource<LocationModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    /*'type',*/ 'defaultIcon',
    'locationName',
    'city',
    'status',
    'Latitude&Longitude',
    'address',
    'shippingType',
    'contacts',
    'action',
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() item: any;
  @Input() locations: LocationModel[] = [];
  @Input() type: LocationType;
  @Input() cancelAddMoreLocations: boolean = false;
  @Input() showAddLocationTypeColumn: boolean = false;
  @Input() readOnly = false;
  @Output() navigateToMap = new EventEmitter();
  @Output() locationId = new EventEmitter();
  @Output() addMoreLocations = new EventEmitter();
  @Output() reload = new EventEmitter();
  location: LocationModel;
  selectedLocation: LocationModel = new LocationModel();
  RolesConstants = RolesConstants;
  LocationType = LocationType;
  sectionState: SectionState;
  sectionStateStatus = SectionState;
  latitude: number = null;
  longitude: number = null;
  totalRowsCount: number;
  @ViewChild('addLocationModal') addLocationModal: TemplateRef<DialogLayoutComponent>;
  AddLocationType = AddLocationType;
  RoutesUtil = RoutesUtil;
  isMyCustomersView: boolean = false;
  parentId: number;
  customerLabel: CompanyLabelType;
  companyLabelType = CompanyLabelType;
  LocationStatus = LocationStatus;

  constructor(
    private locationsApiService: LocationAPI,
    private router: Router,
    private userApi: UserApi,
    public matDialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.filters.params = { offset: 0 };
    this.isMyCustomersView = this.router.url.includes('my-customers');
    this.parentId = this.userApi.currentUser$.value?.parentId;
    this.customerLabel = this.userApi.currentUser$.value?.customerLabel;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locations && changes.locations.currentValue !== changes.locations.previousValue) {
      this.locations = changes.locations.currentValue;
      if (!changes.item?.firstChange) {
        if (!this.locations.length) {
          this.sectionState = SectionState.Empty;
        } else {
          this.sectionState = SectionState.Ready;
        }
      }
      this.setupTable(this.locations);
    }
    if (
      changes.selectedLocation &&
      changes.selectedLocation.currentValue !== changes.selectedLocation.previousValue
    ) {
      this.locations.forEach((location) => (location.selected = false));
      this.selectedLocation.selected = true;
      this.changeLocation(this.selectedLocation.latitude, this.selectedLocation.longitude);
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private setupTable(locations: LocationModel[]) {
    this.filters.data$;
    this.locations = locations;
    this.filters.data$.pipe(takeUntil(this.destroy$)).subscribe(({ offset, limit }) => {
      this.dataSource.data = (this.locations || []).slice(offset * limit, (offset + 1) * limit);
      this.dataSource.sort = this.sort;
      this.totalRowsCount = this.locations?.length;
    });
  }

  onNavigateToMap(location) {
    this.navigateToMap.emit(location);
    this.onSelectLocation(location);
  }

  onSetAsDefault(location: LocationModel) {
    this.selectedLocation = location;
    const body: Partial<LocationModel> = {
      isDefault: true,
      id: location.id,
      shippingType: location.shippingType,
    };
    this.load(this.locationsApiService.editLocation(body)).subscribe((location) => {
      this.locations.forEach((location) => (location.isDefault = false));
      this.selectedLocation.isDefault = location?.isDefault;
    });
  }

  onChangeStatus(location: LocationModel) {
    location.status =
      location.status === LocationStatus.Active ? LocationStatus.Inactive : LocationStatus.Active;

    const body: Partial<LocationModel> = {
      status: location.status,
      id: location.id,
      shippingType: location.shippingType,
    };

    this.load(this.locationsApiService.editLocation(body), {
      fetchOnce: true,
    }).subscribe(
      () => {
        this.showSuccessMessage('SuccessMessages.LocationModifiedSuccessfully');
      },

    );
  }

  onSelectLocation(item: LocationModel) {
    this.locations.forEach((location) => (location.selected = false));
    this.selectedLocation = item;
    item.selected = true;
    this.changeLocation(item.latitude, item.longitude);
  }

  private changeLocation(lat, lng) {
    this.latitude = lat;
    this.longitude = lng;
  }

  onUpdateLocation(event) {
    this.selectedLocation = event;
    this.locations.some((location) => {
      if (location.id === event.id) {
        location.city = event.city;
        return true;
      }
    });
  }

  onAddMoreLocations() {
    if (this.cancelAddMoreLocations) {
      this.addMoreLocations.emit();
    } else {
      this.selectedLocation = {} as any;
      this.matDialog.open(this.addLocationModal);
    }
  }

  onAddLocation(id: number) {
    this.locations = this.item?.locations;
    this.locationId.emit(id);
  }
}
